import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=59a92658&scoped=true&"
import script from "./Answers.vue?vue&type=script&lang=ts&"
export * from "./Answers.vue?vue&type=script&lang=ts&"
import style0 from "./Answers.vue?vue&type=style&index=0&id=59a92658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a92658",
  null
  
)

export default component.exports